var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFormInput',_vm._g(_vm._b({attrs:{"label-text":_vm.labelText,"value":_vm.formattedValue},on:{"update":_vm.onUpdate}},'BaseFormInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }